module.exports = __webpack_public_path__ + "static/media/client-logo-25.64773a91.jpg";